// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore Turf 6.5's package exports do not expose its bundled declarations to TypeScript's bundler resolution.
import { convertLength } from "@turf/helpers";
import { UnitOfMeasurement } from "@iventis/domain-model/model/unitOfMeasurement";
import { metersInKilometer, feetInMile } from "./constants";

/**
 * Converts length value to Metric or imperial and then to an easily readable value. eg) "10,000 m" changes to "10 km"
 * @param length - Measurement value in meters
 * @param unitOfMeasurement - Metric or imperial system
 * @returns converted length with unit appended. eg) "10 m" or "7.2 mi"
 */
export function convertLengthMeasurement(length: number, unitOfMeasurement: UnitOfMeasurement) {
    switch (unitOfMeasurement) {
        case UnitOfMeasurement.Metric:
            return convertMetric(length);
        case UnitOfMeasurement.Imperial:
            return convertImperial(length);
        default:
            throw new Error(`Unit of measurement ${unitOfMeasurement} is not supported`);
    }
}

// eslint-disable-next-line prettier/prettier
function convertMetric(length: number): `${number} m` | `${number} km` {
    if (length >= metersInKilometer) {
        return `${(length / metersInKilometer).toFixed(2) as `${number}`} km`;
    }
    return `${length.toFixed(2) as `${number}`} m`;
}

// eslint-disable-next-line prettier/prettier
function convertImperial(length: number): `${number} mi` | `${number} ft` {
    const lengthFeet = convertLength(length, "meters", "feet");
    if (lengthFeet >= feetInMile) {
        return `${(lengthFeet / feetInMile).toFixed(2) as `${number}`} mi`;
    }
    return `${lengthFeet.toFixed(2) as `${number}`} ft`;
}

export function convertLengthMetersToFeet(metersValue: number) {
    return convertLength(metersValue, "meters", "feet");
}

export function convertLengthFeetToMeters(feetValue: number) {
    return convertLength(feetValue ?? 0, "feet", "meters");
}
